import React, { useContext, useEffect, useState } from "react";
import "./DuesAndLedger.css";
import ClientLeftSection from "components/ui/ClientFlow/clientLeftAndRightSection/ClientLeftSection";
import { useLocation, useParams } from "react-router-dom";
import ClientRightSection from "components/ui/ClientFlow/clientLeftAndRightSection/ClientRightSection";
import { getIcon } from "utils/iconsConfig";
import { useGlobalContext } from "context/GlobalContext";
import { Divider } from "@mui/material";
import SortContext from "context/SortContext";
import { fetchJewelTransId, useDuesTransaction, useJewelAndDesign, useLedgerTransaction, useSingleDuesItem } from "./api";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import { formatCurrency, formatShortAmount } from "utils/formatCurrency";
import apiClient from "lib/api-client";
import { useQuery } from "@tanstack/react-query";

const DuesAndLedgerDetails = () => {
  const { check, clientId } = useParams();
  const [selectedLeftCard, setSelectedLeftCard] = useState(null);
  const [jewelTransId, setJewelTransId] = useState(null);
  const location = useLocation();
  const [selectedRightData, setSelectedRightData] = useState({
    header: "Select a card",
    items: [],
  });

  const isLedgerPage = location?.state?.ledger;

  const allDues = location?.state?.allDues;

  const getCurrentFinancialYear = () => {
    const now = new Date();
    return now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
  };

  const financialYear = location?.state?.financialYear || getCurrentFinancialYear();

  const {
    setFilterChangeCount,
    setDisplayCount,
    setFilterChangeDesignCount,
    setSearchResultCount,
    setSearchSuffix,
    setDynamicFilterCount,
    dynamicfilterCount,
    filterChangeCount,
    filterChangeDesignCount,
    setSearchPlaceHolder,
  } = useGlobalContext();

  const { setSearch, search } = useContext(SortContext);

  // Dues Transaction

  const { data: dueData, isLoading, isError } = useDuesTransaction({ clientCode: clientId, AllDues: allDues, isLedgerPage });

  const duesData = {
    items: dueData?.data,
  };

  // Ledger Transaction

  const { data: ledgersData, isLoading: isLedgerLoding, isError: isLedgerError, refetch } = useLedgerTransaction({ clientCode: clientId, searchBy: "", isLedgerPage, financialYear });

  const ledgerData = {
    items: ledgersData?.data?.ledgerDetail,

    summary: ledgersData?.data?.ledgerSummary,
  };

  const getData = () => {
    switch (check) {
      case "Dues":
        return duesData;
      case "Ledger":
        return ledgerData;
      default:
        return [];
    }
  };

  const getHeader = () => {
    switch (check) {
      case "Dues":
        return `Transaction - ${dueData?.totalTransactionCount || 0}`;
      case "Ledger":
        return `Transaction - ${ledgersData?.data?.ledgerDetail.length || 0}`;
      default:
        return "Details";
    }
  };

  const getType = () => {
    switch (check) {
      case "Dues":
        return "dues";
      case "Ledger":
        return "ledger";
      default:
        return "dues";
    }
  };

  const data = getData();

  // Single View Items

  const selectedItem = data?.items?.find((item) => item?.TransactionNo === selectedLeftCard?.TransactionNo);

  const transactionNo = selectedLeftCard?.TransactionNo;

  // const { data: designData, isLoading: isDesignLoading, isError: isDesignError } = useSingleDuesItem(jewelTransId);
  const { data: designData, isLoading: isDesignLoading, isError: isDesignError } = useJewelAndDesign(transactionNo);

  const renderLedgerSummary = () => {
    if (check !== "Ledger") return null;

    const summaryContainerStyle = {
      display: "flex",
      gap: "20px",
      marginBottom: "30px",
    };

    const summaryBoxStyle = {
      flex: 1,
      background: "#141414",
      borderRadius: "10px",
      padding: "12px 16px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
    };

    const summaryTitleStyle = {
      fontSize: "14px",
      fontWeight: "500",
      color: "#FCFAFA",
      fontFamily: "Karla",
      lineHeight: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      whiteSpace: "nowrap"
    };

    const iconContainerStyle = {
      width: "28px",
      height: "28px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#262626",
    };

    const summaryData = [
      {
        title: "Total",
        amount: ledgerData?.summary?.LedgerTotal || 0,
        icon: getIcon("Total_Ledger_Icon"),
      },
      {
        title: "Received",
        amount: ledgerData?.summary?.Credit || 0,
        icon: getIcon("Received_Icon"),
      },
      {
        title: "Closing Balance",
        amount: ledgerData?.summary?.ClosingDebit || ledgerData?.summary?.ClosingCredit,
        icon: getIcon("Wallet_Icon"),
      },
    ];

    return (
      <div style={summaryContainerStyle}>
        {summaryData.map((box, index) => (
          <div key={index} style={summaryBoxStyle}>
            <div style={summaryTitleStyle}>
              <span style={iconContainerStyle}>{box?.icon}</span> {box.title} :
            </div>
            <div
              style={{
                fontSize: "18px",
                fontWeight: 600,
                color: box.title === "Closing Balance" ? (ledgerData?.summary?.ClosingDebit > 0 ? "#50C878" : "#E77B7B") : "#FCFAFA",
                fontFamily: "Poppins",
                whiteSpace: "nowrap"
              }}
            >
              {/* {formatCurrency(box.amount)} */}
              <>
                {formatCurrency(box.amount)}
                {" "}
                <span style={{ fontSize: "14px", opacity: 0.8 }}>
                  ({formatShortAmount(box.amount)})
                </span>
              </>
            </div>
          </div>
        ))}
      </div>
    );
  };

  useEffect(() => {
    return () => {
      setSearchPlaceHolder("");
      setSearch(false);
      setSelectedLeftCard(null);
    };
  }, []);

  useEffect(() => {
    if (check === "Ledger") {
      setSearch(true);
      setSearchPlaceHolder("Search Transaction number");
      return;
      // return () => {
      //   setSearchPlaceHolder("");
      //   setSearch(false);
      // }
    }

    const totalDues = dueData?.totalDuesClosingBalance;

    setSearch(true);
    setSearchPlaceHolder("Search Transaction number");

    if (search === "") {
      setDynamicFilterCount(true);
    }

    if (dynamicfilterCount) {
      setFilterChangeCount(totalDues);
      setFilterChangeDesignCount(totalDues);
      setSearchResultCount(0);
    } else {
      setSearchResultCount(0);
      setFilterChangeCount(filterChangeCount);
      setFilterChangeDesignCount(filterChangeDesignCount);
    }

    setDisplayCount(true);
    setSearchSuffix("");

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchSuffix("");
    };
  }, [search, dynamicfilterCount, dueData]);

  // const transactionNo = selectedLeftCard?.TransactionNo;

  // const { data: jewelData, isLoading: jewelLoading } = useQuery({
  //   queryKey: ["jewelTransId", transactionNo],
  //   queryFn: () => fetchJewelTransId(transactionNo),
  //   enabled: !!transactionNo,
  //   retry: 0,
  // });

  // useEffect(() => {
  //   if (!selectedLeftCard) return;

  //   if (jewelData?.JewelTransId) {
  //     setJewelTransId(jewelData.JewelTransId);
  //   } else {
  //     // reset immediately if fetch failed or no ID
  //     setJewelTransId(null);
  //     setSelectedRightData({
  //       header: `${selectedLeftCard.TransactionNo} items - 0`,
  //       items: [],
  //     });
  //   }
  // }, [jewelData, selectedLeftCard]);

  useEffect(() => {
    if (selectedLeftCard) {
      setSelectedRightData({
        header: `${selectedLeftCard.TransactionNo} items - ${designData?.designData?.length || 0}`,
        items: designData?.designData || [],
      });
    }
  }, [designData, selectedLeftCard]);

  return (
    <div className="dues-ledger-container">
      {renderLedgerSummary()}
      <Divider sx={{ height: "4px", background: "#0D0D0D", borderBottom: "none", marginLeft: "-22px" }} />
      <div className="content-wrapper">
        {/* Left Section - Transactions - Takes 1/3 */}
        <div className="client-left-section">
          <ClientLeftSection data={getData()} header={getHeader()} type={getType()} selectedCard={selectedLeftCard} setSelectedCard={setSelectedLeftCard} />
        </div>
        <Divider orientation={"vertical"} sx={{ width: "4px", background: "#0D0D0D", border: "none", marginTop: "-20px" }} />
        {/* Right Section - Items - Takes 2/3 */}
        <div className="client-right-section">
          <ClientRightSection data={selectedRightData} type={getType()} isLoading={isDesignLoading} JewelTransId={designData?.JewelTransId} />
        </div>
      </div>
    </div>
  );
};

export default DuesAndLedgerDetails;
